<div class="flex flex-col max-h-[90vh] overflow-hidden rounded-2xl bg-white dark:bg-zinc-900" [overlayLoader]="loading">
  <div class="flex items-center justify-between shrink-0 px-6 py-4 bg-primary text-white shadow-sm">
    <div class="flex items-center gap-x-3 min-w-0">
      <div class="flex-shrink-0 w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center">
        <mat-icon class="icon-size-5 !text-white" [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
      </div>
      <div class="min-w-0">
        <h2 class="text-lg font-semibold !text-white truncate">Edit Company Profile</h2>
        <p class="text-xs text-white/80 truncate">
          {{ showCompanyPermissions ? 'Update company information and permissions' : 'Update company information' }}
        </p>
      </div>
    </div>
    <button mat-icon-button type="button" class="shrink-0 !text-white hover:!bg-white/10" (click)="close()" aria-label="Close">
      <mat-icon class="!text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
  </div>

  <div class="px-5 py-4 flex-1 overflow-y-auto min-h-0" mat-dialog-content>
    <form [formGroup]="form" class="flex flex-col gap-5">
      <div class="flex items-center gap-4">
        <label
          class="group relative flex h-20 w-20 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-full border-2 border-dashed border-neutral-300 bg-neutral-50 transition hover:border-primary dark:border-neutral-600 dark:bg-zinc-800 dark:hover:border-primary">
          @if (!logoPreview) {
            <mat-icon
              class="icon-size-7 text-neutral-400 transition group-hover:text-primary dark:text-zinc-500"
              [svgIcon]="'heroicons_outline:camera'"></mat-icon>
          } @else {
            <img [src]="logoPreview" class="h-full w-full object-cover" alt="Company logo" />
          }
          <input type="file" accept="image/*" hidden (change)="onLogoChange($event)" />
        </label>
        <div class="min-w-0">
          <p class="text-sm font-medium text-neutral-800 dark:text-neutral-200">Company logo</p>
          <p class="text-xs text-secondary mt-0.5">Click the image to upload a new logo</p>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
        <mat-form-field class="fuse-mat-dense w-full">
          <mat-label>Company Name</mat-label>
          <input matInput formControlName="name" placeholder="Company name" />
          <mat-icon matSuffix class="icon-size-4 text-secondary" [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full">
          <mat-label>Company Code</mat-label>
          <input matInput formControlName="companyCode" placeholder="CMP-001" />
          <mat-error *ngIf="form.get('companyCode')?.hasError('required')">Company code is required</mat-error>
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email" placeholder="company&#64;example.com" />
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" placeholder="+92-xxx-xxx-xxxx" />
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full">
          <mat-label>Website</mat-label>
          <input matInput formControlName="website" placeholder="https://www.example.com" />
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full">
          <mat-label>Country</mat-label>
          <input matInput formControlName="country" placeholder="Pakistan" />
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" placeholder="Lahore" />
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full">
          <mat-label>Timezone</mat-label>
          <input matInput formControlName="timezone" placeholder="Asia/Karachi" />
          <mat-icon matSuffix class="icon-size-4 text-secondary" [svgIcon]="'heroicons_outline:lock-closed'"></mat-icon>
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense w-full sm:col-span-2">
          <mat-label>Address</mat-label>
          <textarea matInput formControlName="address" rows="2" placeholder="Full address"></textarea>
        </mat-form-field>
      </div>

      @if (showCompanyPermissions) {
        <div class="pt-1">
          <div class="mb-3 flex items-center gap-2">
            <mat-icon
              class="icon-size-5 text-neutral-700 dark:text-neutral-200"
              [svgIcon]="'heroicons_outline:shield-check'"></mat-icon>
            <h3 class="text-base font-semibold text-neutral-900 dark:text-white">Company Permissions</h3>
          </div>

          @if (permissionsLoading) {
            <div class="flex items-center justify-center py-8">
              <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
            </div>
          } @else if (permissions.length === 0) {
            <p class="text-secondary py-4 text-center text-sm">No permissions available.</p>
          } @else {
            <p class="mb-3 text-sm text-secondary">
              {{ canEditPermissions ? 'Select module permissions for this company' : 'Module permissions for this company' }}
            </p>
            <div class="flex flex-wrap gap-x-4 gap-y-1">
              @for (perm of permissions; track trackPermissionRow($index, perm)) {
                @if (canEditPermissions) {
                  <label
                    class="flex items-center gap-2 rounded-lg px-2 py-1.5 transition-colors hover:bg-neutral-100/80 dark:hover:bg-zinc-800/60">
                    <mat-checkbox
                      color="primary"
                      [checked]="isModulePermissionChecked(perm)"
                      (change)="toggleModulePermission(perm, $event.checked)"></mat-checkbox>
                    <span class="whitespace-nowrap text-sm font-medium text-neutral-700 dark:text-neutral-300">
                      {{ getPermissionLabel(perm) }}
                    </span>
                  </label>
                } @else {
                  <div class="flex items-center gap-2 rounded-lg px-2 py-1.5">
                    @if (isModulePermissionChecked(perm)) {
                      <mat-icon
                        class="icon-size-5 text-primary"
                        [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                    } @else {
                      <mat-icon
                        class="icon-size-5 text-neutral-300 dark:text-neutral-600"
                        [svgIcon]="'heroicons_outline:minus-circle'"></mat-icon>
                    }
                    <span class="whitespace-nowrap text-sm font-medium text-neutral-700 dark:text-neutral-300">
                      {{ getPermissionLabel(perm) }}
                    </span>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    </form>
  </div>

  <div class="flex items-center justify-end gap-2 shrink-0 px-5 py-3 border-t border-neutral-200 dark:border-zinc-700">
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="loading || form.invalid"
      [overlayLoader]="loading"
      (click)="submit()">
      <mat-icon>save</mat-icon>
      <span class="ms-2">{{ loading ? 'Saving...' : 'Save' }}</span>
    </button>
  </div>
</div>
